import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';
import { generatePath, useNavigate } from 'react-router-dom';

import { Button, ButtonType } from '../../components';
import { useDependencies } from '../../dependencies';
import { Routes } from '../../Routes';

export const MembershipPayment = (): JSX.Element => {
  const { stores } = useDependencies();
  const { t } = useSharedTranslation (namespaces.caregiver);
  const navigate = useNavigate();

  const handlePaymentClick = (): void => {
    const route = generatePath(Routes.user.creditCard, { id: stores.user.user.id });
    navigate(route);
  };

  return (
    <div className='mb-10 border-2 rounded-2xl p-3'>
      <div className='mb-2.5 font-bold'>{t('pages.sitter.payout.paymentMethod')}</div>
      <hr className='mb-3.5' />
      <p className='mb-5'>{t('pages.sitter.payout.paymentMethodDescription')}</p>
      <div className='mb-2'>
        <Button buttonType={ButtonType.secondary} onClick={handlePaymentClick}>
          {t('pages.sitter.payout.paymentMethodButton')}
        </Button>
      </div>
    </div>
  );
};
